<template>
    <!-- Modal -->

    <div class="modal fade" id="newTask" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
         aria-hidden="true">
        <div class="modal-dialog " role="document">
            <div class="modal-content">
                <div class="modal-header" style="border-bottom: unset">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">

                        <div class="col-md-7 col-12 pl-md-5 pr-md-5">
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <h5 class="text-uppercase" v-if="isEdit">Edit  responsiblity</h5>
                                    <h5 class="text-uppercase" v-else>Create new responsiblity</h5>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Created by:</label><br>
                                        <div class="row mt-3 ml-2">
                                            <div class="col-lg-12">
                                                <input class="form-check-input ml-1 mt-1" type="checkbox" value="">
                                                <label class="ml-4">Your member name</label>
                                            </div>
                                        </div>
                                        <label class="ml-4 mt-2 mb-2">Or one of your committees (if any)</label><br>
                                        <div class="row ml-2">
                                            <div class="col-lg-6">
                                                <input class="form-check-input ml-1 mt-1" type="checkbox" value="">
                                                <label class="ml-4">Committeename</label>
                                            </div>
                                            <div class="col-lg-6">
                                                <input class="form-check-input ml-1 mt-1" type="checkbox" value="">
                                                <label class="ml-4">Committeename</label>

                                            </div>
                                            <div class="col-lg-6">
                                                <input class="form-check-input ml-1 mt-1" type="checkbox" value="">
                                                <label class="ml-4">Lorem ipsum</label>
                                            </div>
                                            <div class="col-lg-6">
                                                <input class="form-check-input ml-1 mt-1" type="checkbox" value="">
                                                <label class="ml-4">Lorem ipsum</label>

                                            </div>
                                        </div>


                                    </div>

                                </div>


                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="name">Name</label>
                                        <input type="text" class="form-control" id="name">
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="textarea">Description::</label>
                                        <editor
                                                id="textarea"
                                                v-model="description"

                                                :init="{
								height: 200,
								menubar: false,
                                language:'nl',
								plugins: [
									'advlist autolink lists link image charmap print preview anchor',
									'searchreplace visualblocks code fullscreen',
									'insertdatetime media table paste code help wordcount'
								],
								toolbar:
									'undo redo | formatselect | bold italic backcolor | \
									alignleft aligncenter alignright alignjustify | \
									bullist numlist outdent indent | removeformat | help'
							}"
                                        />
                                    </div>
                                </div>


                                <div class="col-md-6">

                                    <div class="row" v-for="image in img" v-bind:key="image">
                                        <div class="col-lg-1">
                                            <img :src="image"
                                                 alt="" style="width: 25px;height: 25px;border-radius: 50%;">
                                        </div>
                                        <div class="col-lg-7" v-for="file in filename" v-bind:key="file">
                                            <label style="color: #4192D9">{{file}}</label>
                                        </div>
                                        <div class="col-lg-3">
                                            <i class="fa fa-trash" style="color: #4192D9;" aria-hidden="true"></i>
                                        </div>

                                    </div>



                                </div>
                                <div class="col-md-6">
                                    <input class="mt-4 custom-file-input" type="file" id="file"  @change=uploadImage>

<!--                                    <button class="btn-dark float-right">Attach file/s</button>-->

                                </div>


                            </div>
                        </div>
                        <div class="col-md-5 col-12 pl-md-2 pr-md-5">
                            <div class="row">

                                <div class="col-md-12 col-12 mb-3 p-0">
                                    Related committees if proceeds:
                                </div>
                                <div class="col-md-12 col-12 pl-md-5 pt-4 pb-4 container-bg">
                                    <div class="row">
                                        <div class="col-md-10 custom-scrollbar" style="height: 200px;">
                                            <div class="form-check  ">
                                                <input class="form-check-input" type="checkbox" value=""
                                                       id="defaultCheck1">
                                                <label class="form-check-label" for="defaultCheck1">
                                                    Default checkbox
                                                </label>
                                            </div>
                                            <div class="form-check pt-3 ">
                                                <input class="form-check-input" type="checkbox" value=""
                                                       id="defaultCheck1">
                                                <label class="form-check-label" for="defaultCheck1">
                                                    Default checkbox
                                                </label>
                                            </div>

                                        </div>
                                    </div>


                                </div>
                            </div>

                            <div class="row">

                                <div class="col-md-12 col-12 mb-3 p-0">
                                    Related member if proceeds:
                                    <members v-bind:isEdit="isEdit" v-bind:committee="committee"></members>

                                </div>

                            </div>

                        </div>


                    </div>

                    <div class="row">
                        <div class="col-lg-12">
                            <button class="btn-dark float-right mt-3">Done</button>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import members from "../../committees/pages/members";
    export default {
        name: "responsibilityModal",
        components:{
            members
        },
        props:['isEdit'],
        data(){
            return{
                img:[],
                image:[],
                filename:[],
            }
        },
        methods:{
            uploadImage(event){
                var file=event.target.files[0];
                this.filename.push(file.name);
                this.image.push(file);
                this.img.push(URL.createObjectURL(file)) ;

            },
        }
    }
</script>

<style scoped>
    @media (min-width: 576px) {
        .modal-dialog {
            max-width: 900px;
            margin: 1.75rem auto;
            margin-top: 9rem;
        }

        .delete-modal {
            max-width: 600px !important;
            margin: 1.75rem auto;
        }
    }
    .form-control, .input-group-text {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #00000029;
        border-radius: 4px;
        opacity: 1;
        border: 1px #ced4da;;
    }
    .custom-file-input {
        color: transparent;
        opacity: 1 !important;
    }
    .custom-file-input::-webkit-file-upload-button {
        visibility: hidden;
    }
    .custom-file-input::before {
        content: 'Upload';
        color: white;
        display: inline-block;
        background: black;
        border-radius: 3px;
        padding: 5px 12px;
        cursor: pointer;

    }
    .custom-file-input:hover::before {
        border-color: black;
        outline: none;
    }
    .custom-file-input:active {
        outline: none;
    }
    .custom-file-input:active::before {
        background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
        outline: none;
    }
</style>
